import { render, staticRenderFns } from "./ResourceCreateTabAccount.vue?vue&type=template&id=0ee21ab3"
import script from "./ResourceCreateTabAccount.vue?vue&type=script&lang=js"
export * from "./ResourceCreateTabAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports